export const id = ['id'];
export const version = ['version'];
export const type = ['type'];
export const entryPoints = ['entryPoints'];
